/* eslint-disable */
// @ts-nocheck
import { Box, makeStyles, Typography } from '@material-ui/core';
import TransparentPaper from '../../components/TransparentPaper';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
  },
  wrapper: {
    padding: 30,
  },
  header: {
    fontSize: 20,
    color: '#005798',
  },
}));
export const ImpressumTextEnglish = () => {
  const classes = useStyles();
  return (
    <TransparentPaper>
      <Box className={classes.wrapper}>
        <Typography variant="h1">Legal Notice</Typography>
        <p>
          Information according to § 5 TMG
          <br />
        </p>
        <p>
          <span className={classes.header}>Operator and Contact</span>
          <br />
          MoovyMed GmbH
          <br />
          Werftstr. 12
          <br />
          76189 Karlsruhe
        </p>
        <p>
          Email: <a href="mailto:info@moovymed.de">info@moovymed.de</a>
          <br />
          <br />
          Phone number: +49 721 4763350
        </p>
        <p>
          <span className={classes.header}>Representation</span>
          <br />
          MoovyMed GmbH is represented by the managing directors Dr. Martin
          Benedict | Martin Taller
          <br />
          <br />
          Register court: Amtsgericht Mannheim HRB 748972
        </p>
        <p>
          <span className={classes.header}>
            Online dispute resolution according to Art. 14 Abs. 1 ODR-VO
          </span>
          <br />
          The European Commission provides a platform for online dispute
          resolution (OS):{' '}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          . You can find our email address in the legal notice above. We are not
          willing or obliged to participate in dispute resolution proceedings
          before a consumer arbitration board.
        </p>
        <p>
          <span className={classes.header}>Image Credits</span>
          <br />
          iStock 612016238:{' '}
          <a
            href="https://www.istockphoto.com/portfolio/filadendron?mediatype=photography"
            target="_blank"
            rel="noopener noreferrer"
          >
            Todor Tsvetkov
          </a>
          <br />
          iStock 611776510:{' '}
          <a
            href="https://www.istockphoto.com/portfolio/cyano66?mediatype=photography"
            target="_blank"
            rel="noopener noreferrer"
          >
            cyano66
          </a>
          <br />
          iStock 611776510:{' '}
          <a
            href="https://www.istockphoto.com/portfolio/cyano66?mediatype=photography"
            target="_blank"
            rel="noopener noreferrer"
          >
            cyano66
          </a>{' '}
          unsplash hIz3vbUbOoI:{' '}
          <a
            href="https://unsplash.com/@danny144"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dan Nelson
          </a>
        </p>
      </Box>
    </TransparentPaper>
  );
};
